import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-context-history',
    templateUrl: './icon-context-history.component.html',
    styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconContextHistoryComponent {
    @Input() isActive: boolean = false;
}
